<div *ngIf="enable" class="error-message">
  {{message}}
  <strong>{{bold}}</strong>
</div>
